/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * 
 */
export type QueuedJobState = 0 | 1 | 2 | 3 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17;

export const QueuedJobState = {
    NUMBER_0: 0 as QueuedJobState,
    NUMBER_1: 1 as QueuedJobState,
    NUMBER_2: 2 as QueuedJobState,
    NUMBER_3: 3 as QueuedJobState,
    NUMBER_9: 9 as QueuedJobState,
    NUMBER_10: 10 as QueuedJobState,
    NUMBER_11: 11 as QueuedJobState,
    NUMBER_12: 12 as QueuedJobState,
    NUMBER_13: 13 as QueuedJobState,
    NUMBER_14: 14 as QueuedJobState,
    NUMBER_15: 15 as QueuedJobState,
    NUMBER_16: 16 as QueuedJobState,
    NUMBER_17: 17 as QueuedJobState
};
